/**
 *  Autopilot Publisher client-side core js
 *  @date 06-Nov-2024
 *
 *  Example:
 *  <script
 *    id='be-app-script'
 *    type='text/javascript'
 *    async=true
 *    src='https://app-cf.bc0a.com/corejs/be-app.js'
 *    data-customerid='f00000'
 *    data-env='production' // optional
 *    data-timedelay='0' // millis
 *  >
 *  </script>
*/
; (function () {
  var beAppVersion = '1.18.7';
  var BE_APP_SCRIPT_ID = 'be-app-script';
  var beAppDebug = false, beAppDelay = 0, beAppEnabled = true, beAppIgnoreQueryParams = false, beAppIsProdEnv = true, beAppTestmode = false, beAppWhitelistedParams = '', testmodeparameter = false;
  var beAppDelayParam, beAppMetaParam, beAppNewH1Param, beAppOldH1Param, beAppTitleParam, beAppUseCDNParameter = true;
  var beAppCustomerId, beAppEnv;

  // Constants
  var BE_APP = "data-be-app", BE_APP_PROCESSED = "processed", BE_APP_HIDDEN = "hidden", BE_APP_CAPTURED = "captured";
  var BE_APP_CONFIG_DOMAIN_STAGE = 'https://app-test-be.s3.us-east-2.amazonaws.com';
  var BE_APP_CONFIG_DOMAIN_PROD = 'https://app-cf.bc0a.com';
  var BE_APP_CONFIG_DOMAIN_PROD_S3 = 'https://app-be.s3.us-east-2.amazonaws.com';
  var BE_APP_API_STAGE = 'https://app-qa-cdn.bc0a.com';
  var BE_APP_API_PROD = 'https://app-cdn.bc0a.com';

  var beAppConfigData = null;

  function beProcessExistingH1s() {
    var existingH1s = document.getElementsByTagName('h1');
    for (var i = 0; i < existingH1s.length; i++) {
      var h1 = existingH1s[i];
      if (!h1.getAttribute(BE_APP)) {
        h1.setAttribute(BE_APP, BE_APP_CAPTURED);
      }
    }
  }

  function beMonitorH1AdditionsAndProcess() {
    // Process any existing h1 elements in the DOM
    beProcessExistingH1s();

    // Helper function to process nodes for h1
    function processNode(node) {
      if (node.nodeType === 1) { // Element node
        if (node.tagName.toLowerCase() === 'h1') {
          var app_processed = node.getAttribute(BE_APP);
          if (!app_processed) {
            if (!beAppConfigData) {
              node.style.visibility = 'hidden';
              node.setAttribute(BE_APP, BE_APP_HIDDEN);
              beAppLog('h1 hidden from inside mutation observer: ', node);
            } else {
              beProcessH1Replacement(node);
            }
          }
        } else {
          // Directly check for h1 nodes inside the added node
          var h1_nodes = node.querySelectorAll('h1');
          for (var i = 0; i < h1_nodes.length; i++) {
            processNode(h1_nodes[i]);
          }
        }
      }
    }

    // Mutation observer to track added nodes
    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        var mutation = mutations[i];
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          for (var j = 0; j < mutation.addedNodes.length; j++) {
            processNode(mutation.addedNodes[j]);
          }
        }
      }
    });

    // Start observing the document body or document element
    var targetNode = document.body || document.documentElement;
    observer.observe(targetNode, { childList: true, subtree: true });
  }


  // beEnableAPPublisher();
  function enableApp(appConfig) {
    try {
      var beAppScriptNode = document.getElementById(BE_APP_SCRIPT_ID);
      var beAppDebugAlways = false;
      if (beAppScriptNode) {
        beAppDebugAlways = beAppScriptNode.getAttribute('data-debug-always') === 'true';
      } else if (appConfig) {
        beAppDebugAlways = appConfig['data-debug-always'];
      }
      if (beAppDebugAlways || beGetParameterByName('beapp-debug') === 'true') {
        beAppDebug = true;
      }

      beAppLog('checking AP Publisher');
      if (beAppScriptNode) {
        beAppCustomerId = beAppScriptNode.getAttribute('data-customerid');
        beAppTestmode = beAppScriptNode.getAttribute('data-testmode');
        beAppEnv = beAppScriptNode.getAttribute('data-env');
        beAppDelay = parseInt(beAppScriptNode.getAttribute("data-delay"), 10) || 0;
        beAppIgnoreQueryParams = beAppScriptNode.getAttribute('data-ignorequeryparams') === 'true';
        beAppWhitelistedParams = beAppScriptNode.getAttribute('data-whitelist-params');
      }
      else if (appConfig) {
        beAppCustomerId = appConfig['data-customerid'];
        beAppTestmode = appConfig['data-testmode'];
        beAppEnv = appConfig['data-env'];
        beAppDelay = parseInt(appConfig["data-delay"], 10) || 0;
        beAppIgnoreQueryParams = appConfig['data-ignorequeryparams'];
        beAppWhitelistedParams = appConfig['data-whitelist-params'];
      }
      else
        return;

      beEnableAPPublisher();
    } catch (e) {
      beAppLog(e);
    }
  }

  function beEnableAPPublisher() {
    beAppLog('[START] AP Publisher');

    testmodeparameter = beGetParameterByName('beapp-testpage') === 'true';
    var testactivateparameter = beGetParameterByName('beapp-activate');
    var envparam = beGetParameterByName('beapp-env');
    beAppDelayParam = parseInt(beGetParameterByName('beapp-delay'), 10) || 0;
    beAppTitleParam = beGetParameterByName('beapp-title');
    beAppMetaParam = beGetParameterByName('beapp-meta');
    beAppOldH1Param = beGetParameterByName('beapp-old-h1');
    beAppNewH1Param = beGetParameterByName('beapp-new-h1');
    beAppUseCDNParameter = beGetParameterByName('beapp-usecdn') !== 'false';
    beAppDelay = beAppDelayParam ? beAppDelayParam : beAppDelay;

    if (beAppTestmode === 'true' || beAppTestmode == true) {
      beAppEnabled = false;
      if (testmodeparameter) {
        beAppEnabled = true;
      }
      if (beAppEnv === 'staging' || beAppEnv === 'stage') {
        beAppIsProdEnv = false;
      }
    }
    else {
      beAppIsProdEnv = true;
      beAppEnabled = true;
      if (testactivateparameter === 'false') {
        beAppEnabled = false;
      }
      if (beAppEnv === 'staging' || beAppEnv === 'stage') {
        beAppIsProdEnv = false;
      }
    }

    if (envparam === 'production' || envparam === 'prod') {
      beAppIsProdEnv = true;
    }
    else if (envparam === 'staging' || envparam === 'stage') {
      beAppIsProdEnv = false;
    }

    beAppLog('beapp-debug=' + beAppDebug);
    beAppLog('beapp-version=' + beAppVersion);
    beAppLog('beapp-enabled=' + beAppEnabled);
    beAppLog('data-customerid=' + beAppCustomerId);
    beAppLog('data-testmode=' + beAppTestmode);
    beAppLog('data-ignorequeryparams=' + beAppIgnoreQueryParams);
    beAppLog('testmodeparameter=' + testmodeparameter);
    beAppLog('usecdnparameter=' + beAppUseCDNParameter);
    beAppLog('beapp-delay=' + beAppDelayParam);
    beAppLog('finaldelay=' + beAppDelay);
    beAppLog('beapp-title=' + beAppTitleParam);
    beAppLog('beapp-meta=' + beAppMetaParam);
    beAppLog('beapp-old-h1=' + beAppOldH1Param);
    beAppLog('beapp-new-h1=' + beAppNewH1Param);

    if (beAppCustomerId) {
      if (beAppEnabled) {
        beAppLog('AP Publisher is enabled');

        // Start monitoring and replacing
        beMonitorH1AdditionsAndProcess();
        if (beAppTitleParam && beAppMetaParam && beAppOldH1Param && beAppNewH1Param) {
          beInitializeProcessing({});
        } else {
          bePreFetchAppConfig(
            function (appData) {
              beAppLog('Pre-fetch completed. Initializing Replacements.');
              beInitializeProcessing(appData);
            },
            function () {
              beAppLog('Error during pre-fetch. Initializing Replacements.');
              beInitializeProcessing({}); // Proceed even if pre-fetch fails
            }
          )
        }
      } else {
        beAppLog('AP Publisher is disabled.');
      }
    } else {
      beAppLog('CustomerID is missing.')
    }
    beAppLog('[END] AP Publisher');
  }

  function bePreFetchAppConfig(callback, errCallback) {
    var pageURL = window.location.href;
    pageURL = processUrlForQueryParams(pageURL, beAppWhitelistedParams);
    if (beAppIgnoreQueryParams) {
      var qstn_index = pageURL.indexOf('?');
      pageURL = qstn_index > -1 ? pageURL.substr(0, qstn_index) : pageURL;
    }
    // remove / from end of path
    if (pageURL.slice(-1) === '/') {
      pageURL = pageURL.slice(0, -1);
    }
    var appInfoURL = beAppGetConfigPath(pageURL);

    // Fetch AP Publisher file
    beAppEndpoint(appInfoURL, null, 'GET', function (appData) {
      // Process AP Publisher file
      if (appData) {
        beAppLog('AP Publisher config pre-fetched successfully:', appData);
        // Process ConfigData
        if (callback) callback(appData);
      } else {
        beAppLog('Failed to fetch AP Publisher config file');
        if (errCallback) errCallback({});
      }
    }, function (error) {
      beAppLog('Error fetching AP Publisher config file: ' + error);
      if (errCallback) errCallback({});
      beAppCreatePlaceholderS3JSON(pageURL);
    });
  }

  function beInitializeProcessing(appData) {
    beAppConfigData = appData;
    // for H1s
    beProcessAPPublisherConfig(true);

    // for title & meta
    if (document.getElementsByTagName('body')[0]) {
      beProcessAPPublisherConfig(false);
    } else {
      document.addEventListener('DOMContentLoaded', function () {
        beAppLog('dom content loaded');
        beProcessAPPublisherConfig(false);
      });
    }
  }

  function beProcessAPPublisherConfig(isH1s) {
    if (isH1s) {
      // For H1s, process immediately without delay
      beAppLog("Executing main logic of AP Publisher for H1s immediately.");
      beProcessH1Replacements();
    } else {
      // For meta & title, apply delay if configured
      function triggerMetaTitleReplacements() {
        beAppLog("Executing main logic of AP Publisher for Meta & Title after a delay of " + beAppDelay + " milliseconds.");
        beProcessMetaTitleReplacements();
      }

      if (beAppDelay > 0) {
        setTimeout(triggerMetaTitleReplacements, beAppDelay);
      } else {
        triggerMetaTitleReplacements();
      }
    }
  }

  function beProcessH1Replacements() {
    beAppLog("Start processing the h1 replacements.");
    // Process both hidden and captured H1s
    var h1sToProcess = document.querySelectorAll('h1[data-be-app="' + BE_APP_HIDDEN + '"], h1[data-be-app="' + BE_APP_CAPTURED + '"]');
    for (var i = 0; i < h1sToProcess.length; i++) {
      beProcessH1Replacement(h1sToProcess[i]);
    }
  }

  function beProcessH1Replacement(h1_node) {
    beAppLog("Start processing the h1 replacement.", h1_node);
    var settings = beAppGetProperty(beAppConfigData, 'settings', {});
    var oldH1Value = beAppGetProperty(settings, 'original_h1', '');
    var newH1Value = beAppGetProperty(settings, 'new_h1', '');

    if ((oldH1Value && newH1Value) || (beAppOldH1Param && beAppNewH1Param)) {
      // Determine the old and new values to use
      var oldH1 = beAppOldH1Param || oldH1Value;
      var newH1 = beAppNewH1Param || newH1Value;

      if (h1_node && decodeHtmlEntities(h1_node.innerHTML) === decodeHtmlEntities(oldH1)) {
        h1_node.innerHTML = newH1;
        beAppLog('Updated h1 tag from "' + oldH1 + '" to "' + newH1 + '".');
      }
    }
    // Unhide H1 if it was hidden
    if (h1_node.getAttribute(BE_APP) === BE_APP_HIDDEN) {
      h1_node.style.visibility = 'visible';
      beAppLog('h1 unhidden: ', h1_node);
    }
    // Mark as processed
    h1_node.setAttribute(BE_APP, BE_APP_PROCESSED);
  }

  function beProcessMetaTitleReplacements() {
    beAppLog("Start processing the meta & title replacements.");
    var settings = beAppGetProperty(beAppConfigData, 'settings', {});
    var titleValue = beAppGetProperty(settings, 'title', '');
    var metaDescValue = beAppGetProperty(settings, 'meta_description', '');

    if (titleValue || beAppTitleParam) {
      var oldTitle = document.title;
      var newTitle = beAppTitleParam || titleValue;
      document.title = newTitle;
      beAppLog('Updated title from "' + oldTitle + '" to "' + newTitle + '".');
    }

    if (metaDescValue || beAppMetaParam) {
      // Find the existing meta description tag, regardless of casing.
      var metaDescTag = document.querySelector('meta[name="description"], meta[name="Description"], meta[name="DESCRIPTION"]');

      if (!metaDescTag) {
        // If no meta description tag exists, create one and append it to the head.
        metaDescTag = document.createElement('meta');
        metaDescTag.setAttribute('name', 'description');
        document.head.appendChild(metaDescTag);
      }

      var oldMeta = metaDescTag.getAttribute('content');
      var newMeta = beAppMetaParam || metaDescValue;
      metaDescTag.setAttribute('content', newMeta);
      beAppLog('Updated meta description from "' + oldMeta + '" to "' + newMeta + '".');
    }
  }

  function decodeHtmlEntities(str) {
    var textarea = document.createElement("textarea");
    textarea.innerHTML = str;
    return textarea.value
      .replace(/<br\s*\/?>/gi, ' ')
      .replace(/&nbsp;|&#160;/g, ' ')
      .replace(/\s+/g, '')
      .trim()
      .toLowerCase();
  }

  function beAppCreatePlaceholderS3JSON(page) {
    var payload = {
      'customerid': beAppCustomerId,
      'page': beAppGetAwsPath(page),
    }
    beAppEndpoint(beAppBaseAPI() + '/page/create', payload, 'POST',
      function (resp) {
        beAppLog("Save empty json for path response: ", resp);
      },
      function (err) {
        beAppLog('Error while saving empty json for path: ', err);
      }
    )
  }

  function beGetParameterByName(name) {
    var match = RegExp('[?&]' + name + '=([^&]*)').exec(window.location.search);
    return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
  }

  function beAppLog() {
    if (beAppDebug) {
      console.log.apply(null, arguments);
    }
  }

  function beAppGetProperty(obj, key, defaultValue) {
    return obj.hasOwnProperty(key) ? obj[key] : defaultValue;
  }

  function beAppGetConfigPath(url) {
    var domain = beAppIsProdEnv ? (beAppUseCDNParameter ? BE_APP_CONFIG_DOMAIN_PROD : BE_APP_CONFIG_DOMAIN_PROD_S3) : BE_APP_CONFIG_DOMAIN_STAGE;
    return domain + '/accounts/' + beAppCustomerId + '/config/'
      + beAppGetAwsPath(url) + '/be_app.json';
  }

  function safeDecodeURIComponent(url) {
    try {
      // Check if the URL contains encoded characters
      if (url.includes('%')) {
        // Try decoding and encoding back to see if it's already decoded
        var decoded = decodeURIComponent(url);
        if (encodeURIComponent(decoded) === url) {
          // If encoding the decoded string matches the original, it's already decoded
          return url;
        }
        return decoded;
      }
    } catch (e) {
    }
    return url; // Return original if no decoding was necessary
  }

  function processUrlForQueryParams(url, whitelistedParamsString) {
    // Handle empty whitelist string
    var whitelistedParams = [];
    if (whitelistedParamsString) {
      whitelistedParams = whitelistedParamsString.split(',').map(function (param) {
        return param.trim(); // Remove any extra spaces
      });
    }

    // Decode URL
    url = safeDecodeURIComponent(url);

    // Extract the protocol and domain
    var protocolIndex = url.indexOf('://');
    var protocol = '';
    if (protocolIndex !== -1) {
      protocol = url.substring(0, protocolIndex + 3);
      url = url.substring(protocolIndex + 3);
    }

    // Remove characters from #
    url = url.split('#')[0];

    // Replace space and + with X
    url = url.replace(/[\s\+]/g, 'X');

    // Get folder and query
    var qstn_index = url.indexOf('?');
    var folder = qstn_index > -1 ? url.substr(0, qstn_index) : url;
    var query = qstn_index > -1 ? url.substr(qstn_index + 1) : '';

    // Handle multiple ? characters in the query
    if (query) {
      var additionalQstnIndex = query.indexOf('?');
      if (additionalQstnIndex !== -1) {
        query = query.substring(0, additionalQstnIndex);
      }
    }

    // Process the query string
    if (query) {
      var params = query.split('&').filter(Boolean);

      // Filter params based on the whitelist (using traditional function)
      var filteredParams = params.filter(function (param) {
        var paramName = param.split('=')[0]; // Extract parameter name
        return whitelistedParams.indexOf(paramName) !== -1; // Check if it's in the whitelist
      });

      // Sort the filtered parameters
      filteredParams.sort();
      query = filteredParams.join('&');
    }

    // Reconstruct the URL with sorted and filtered query parameters
    var processedUrl = protocol + folder;
    if (query) {
      processedUrl += '?' + query;
    }

    return processedUrl;
  }

  function beAppGetAwsPath(url) {
    // decode as utf-8
    url = safeDecodeURIComponent(url);

    // strip protocol
    url = url.replace(/^https?:\/\//, '');

    // remove characters from #
    url = url.split('#')[0];

    // replace space and + with X
    url = url.replace(/[\s\+]/g, 'X');

    // get folder and query
    var qstn_index = url.indexOf('?');
    var folder = qstn_index > -1 ? url.substr(0, qstn_index) : url;
    var query = qstn_index > -1 ? url.substr(qstn_index) : '';

    // encode path and replace %2F with /
    folder = encodeURIComponent(folder).replace(/%2F/g, '/').replace(/'/g, '%27');

    // encode query if any
    query = beAppIgnoreQueryParams ? '' : encodeURIComponent(query);

    // additional encoding fixes
    var ret = String(folder + query)
      .replace(/~/g, '%7E')
      .replace(/!/g, '%21')
      .replace(/\(/g, '%28')
      .replace(/\)/g, '%29');

    // re-construct by removing %
    ret = ret.replace(/%/g, '');

    // remove / from end of path
    if (ret.slice(-1) === '/') {
      ret = ret.slice(0, -1);
    }

    return ret;
  }

  function beAppBaseAPI() {
    return beAppIsProdEnv ? BE_APP_API_PROD : BE_APP_API_STAGE;
  }

  function beAppEndpoint(apiUrl, data, method, callback, errCallback) {
    function beEndpointSuccess(callback, response) {
      if (callback) {
        callback(response);
      }
    }

    function beEndpointError(callback, response) {
      if (callback) {
        callback(response);
      }
    }

    function objectToQueryString(params) {
      var esc = encodeURIComponent;
      var keys = Object.keys(params);
      var query = '';
      for (var i = 0; i < keys.length; i++) {
        query += esc(keys[i]) + '=' + esc(params[keys[i]]);
      }
      return query;
    }

    beAppLog('beAppEndpoint api URL=', apiUrl);
    beAppLog('beAppEndpoint api data=', JSON.stringify(data));
    beAppLog('beAppEndpoint api method=', method);

    var options = {
      method: method || 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    };
    beAppLog('beAppEndpoint api options=', options);

    if (data) {
      if (method === 'GET') {
        apiUrl += '?' + objectToQueryString(data);
      } else {
        options.body = JSON.stringify(data); // body should match Content-Type in headers option
      }
    }

    if (window.fetch) {
      // latest browsers - chrome, ff, opera, safari, edge (excl. IE)
      fetch(apiUrl, Object.assign({}, options)).then(function (resp) {
        if (resp.ok) {
          resp.json().then(function (jsonresp) {
            beEndpointSuccess(callback, jsonresp);
          });
        } else {
          throw Error(resp.statusText);
        }
      }).catch(function (err) {
        beAppLog('beAppEndpoint error', err);
        beEndpointError(errCallback, err);
      });
    }
    else {
      var xhttp;
      if (window.XMLHttpRequest) {
        // IE7-11 incl. old chrome, ff, safari, opera
        xhttp = new XMLHttpRequest();
      } else {
        // IE6 & below
        xhttp = new ActiveXObject('Microsoft.XMLHTTP');
      }
      xhttp.onreadystatechange = function () {
        beAppLog('beAppEndpoint onreadystatechange(IE) state=' + this.readyState + ', status=' + this.status);
        if (this.readyState == 4) { // done
          if (this.status >= 200 && this.status < 300) {
            beEndpointSuccess(callback, this.responseText);
          } else {
            beAppLog('beAppEndpoint error', this.responseText);
            beEndpointError(errCallback, this.responseText);
          }
        }
      };
      xhttp.open(method, apiUrl, true);
      xhttp.setRequestHeader('Content-Type', 'application/json');
      if (method === 'GET') {
        xhttp.send();
      } else {
        xhttp.send(JSON.stringify(data));
      }
    }
  }

  // Enable the ability to use APP JS both as an inline script as an NPM package.
  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = enableApp).enableApp = enableApp;
    // Export for CommonJS support.
    freeExports.enableApp = enableApp;
  } else {
    // Export to the global object.
    root.enableApp = enableApp;
    enableApp(null);
  }
})();
